import React from "react";
import { makeStyles, withStyles } from "@material-ui/core";
import {
  Grid,
  TextField,
  Typography,
  Button,
  CircularProgress,
  Link,
} from "@material-ui/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import { store } from "../../../../../helpers";
import { useEffect } from "react";
import { black, red500 } from "material-ui/styles/colors";
import { config } from "../../../../../enviroment";
import { useHistory } from "react-router-dom";
import { routePaths } from "../../../../config/route-paths";
import { AlertTitle, Alert, Skeleton } from "@material-ui/lab";
import { adminService } from "../../../../../services/admin.service";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  alertStyles: {
    color: theme.palette.eDanger.dark,
    backgroundColor: theme.palette.eDanger.light,
    padding:'2%'
  },
  circularProgressColor: {
    color: theme.palette.eWhite.base,
  },
  scrollBar: {
    display: "block",
    flexDirection: "column",
    overflow: "scroll",
    overflowX: "hidden",
    width: "inherit !important",
    margin: "1% 2%",
    padding: "0% 5%",
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.eLight.base,
      borderRadius: 4,
    },
  },
  cancelButton: {
    textTransform: "none",
    color: theme.palette.ePrimary.base,
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    textDecoration: "underline",
    display: "inline",
    margin: 0,
    padding: 0,
  },
  loginSubmitBtn: {
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
    backgroundColor: theme.palette.ePrimary.base,
    width: "75%",
    borderRadius: 28,
    color: theme.palette.eWhite.base,
  },
  mobileNumberError: {
    fontSize: "0.75em",
    color: theme.palette.eDanger?.dark + "!important",
    textAlign: "left",
  },
  registerTitle: {
    color: theme.palette.ePrimary.base,
    
  },
  blackColor: {
    color: theme.palette.eRich.base + "!important",
  },
  blackColor:{
    color:theme.palette.eRich.base + "!important"
  },
  mainDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.up("sm")]: {
      height: "29rem",
    },
    [theme.breakpoints.up("md")]: {
      height: "24rem",
    },
  },
  infoListHeader: {
    textAlign: "initial",
    color: theme.palette.ePrimary.base
  },
  infoListItem: {
    textAlign: "initial"
  },
  mt4:{
    fontSize:'0.75rem'
  },
  marginTitle:{
    marginTop:'2rem'
  }
}));
  
export const CssTextField = withStyles((theme) => ({
  root: {
    "& .MuiInputBase-input": {
      padding: "1px !important",
      fontSize: "0.8em",
    },
    "& .MuiInputBase-input:focus": {
      fontSize: "1rem !important",
    },
    "& .MuiFormHelperText-root.Mui-error": {
      ["@media (min-width:768px)"]: {
        width: "32vw",
      },
      ["@media (min-width:900px)"]: {
        width: "30vw",
      },
      ["@media (min-width:1025px)"]: {
        width: "16vw",
      },
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.eDanger?.dark,
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: theme.palette.eDanger?.dark,
    },
    "& ::placeholder": {
      color: theme.palette.eDark?.base,
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: theme.palette.eDanger?.dark,
    },
  },
}))(TextField);

export const customGrid = withStyles((theme) => ({
  root: {
    "& .MuiGrid-item": {
      margin: 0,
      boxSizing: "border-box",
      width: "99%",
    },
  },
}))(Grid);
  
export default function EForgotPasswordForm(props) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordRequire, setPasswordRequire] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordRequire, setConfirmPasswordRequire] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [isLoading, setLoading] = useState(false);
  let [errorMessage, setErrorMessage] = useState("");
  const history = useHistory();
  const { t: labels, ready: labelReady } = useTranslation("label-E_AUTH_FORGOT_PASSWORD");
  const classes = useStyles();
  const passwordRegex = store.getState()?.parametersWidgets?.ParameterLookup?.E_PASSWORD_REGEX;

  let handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "password") {
      setPassword(value);
    }
    if (name === "confirmPassword") {
      setConfirmPassword(value);
    }
  };

  let passwordBlur = () => {
    if (password.trim()) {
      setPasswordRequire(false);
      let passwordRegExp = new RegExp(passwordRegex);
      if (passwordRegExp.test(password)) {
        setPasswordError(false);
      } else {
        setPasswordError(true);
        setConfirmPasswordError(false);
      }
    } else {
      setPasswordRequire(true);
      setPasswordError(false);
    }
  };

  let confirmPasswordBlur = () => {
    if (confirmPassword) {
      setConfirmPasswordRequire(false);
      if (confirmPassword && password) {
        if (confirmPassword === password) {
          setConfirmPasswordError(false);
        } else {
          setConfirmPasswordError(true);
          setPasswordRequire(false);
          setPasswordError(false);
        }
      } else {
        setConfirmPasswordError(false);
        setPasswordRequire(false);
        setPasswordError(false);
      }
    } else {
      setConfirmPasswordRequire(true);
      setConfirmPasswordError(false);
    }
  };

  let keypress = (event) => {
    if (event.key === "Enter") {
      passwordBlur();
      confirmPasswordBlur();
      if (!isLoading) {
        updatePassword(event);
      }
    }
  };
  let updatePassword = (e) => {
    passwordBlur();
    confirmPasswordBlur();
    if (password && confirmPassword) {
      if (
        !passwordRequire &&
        !passwordError &&
        !confirmPasswordRequire &&
        !confirmPasswordError && password===confirmPassword
      ) {
       let cNo= localStorage.getItem("updating")
        setLoading(true);
        props.forgotPassword(props.userName, "UPDATE_PASSWORD", props.sessionId, password,cNo)
          .then((response) => {
            if(response?.data?.isOk === true) {
              history.push({pathname: routePaths.ACTIVATE_EMAIL, state: { path: routePaths.FORGOT_PASSWORD }})
            } else {
              setErrorMessage(labels("E_FP_GENERAL_ERROR_MSG"))
            }
            setLoading(false);
          })
          .catch((error) => {
            if (error?.response?.status === 400 ) {
              if(error?.response?.data?.message === "SERVICE_NOT_WORKING") {
                setErrorMessage(labels("E_FP_SERVICE_NOT_WORKING_ERROR_MSG"));
              } else if(error?.response?.data?.message === "FORGOT_SESSION_EXPIRED") {
                setErrorMessage(labels("E_FP_FORGOT_SESSION_EXPIRED_ERROR_MSG"));
              } else if(error?.response?.data?.message === "INVALID_ACTION") {
                setErrorMessage(labels("E_FP_INVALID_ACTION_ERROR_MSG"));
              } else if(error?.response?.data?.message) {
                setErrorMessage(error?.response?.data?.message)
              } else {
                setErrorMessage(labels("E_FP_GENERAL_ERROR_MSG"));
              }
            } else if (error?.response?.status === 401 ) {
              if(error?.response?.data?.message === "NOT_ALLOWED") {
                setErrorMessage(labels("E_FP_NOT_ALLOWED_ERROR_MSG"));
              } else if(error?.response?.data?.message) {
                setErrorMessage(error?.response?.data?.message)
              } else {
                setErrorMessage(labels("E_FP_GENERAL_ERROR_MSG"));
              }
            } else if (error?.response?.status === 404 ) {
              if(error?.response?.data?.message === "USER_NOT_FOUND") {
                setErrorMessage(labels("E_FP_USER_NOT_FOUND_ERROR_MSG"));
              } else if(error?.response?.data?.message) {
                setErrorMessage(error?.response?.data?.message)
              } else {
                setErrorMessage(labels("E_FP_GENERAL_ERROR_MSG"));
              }
            } else {
              setErrorMessage(labels("E_FP_GENERAL_ERROR_MSG"));
            }
            setLoading(false);
          })
      }
    } else {
      setConfirmPasswordRequire(true);
      setConfirmPasswordError(false);
    }
  };
  return (
    <>
      <form noValidate className={classes.mainDiv}>
        <Grid container direction="row">
          <Grid item xs={12} className={(errorMessage || passwordError || confirmPasswordError) ? classes.marginTitle : ""}>
          {
            labelReady ?
            <Typography
              align="center"
              variant="h5"
              className={classes.registerTitle}
            >
              {labels("E_FP_UPDATE_PASSWORD_TITLE")} 
            </Typography>
            : <Skeleton />
          }
          </Grid>
          <Grid item xs={12}>
            <Grid container className={classes.scrollBar} spacing={1}>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                  {
                    labelReady ?
                    <Typography
                      variant="subtitle2"
                      align="left"
                      className={classes.blackColor}
                    >
                      {labels("E_FP_NEW_PASSWORD") + "*"}
                    </Typography>
                    : <Skeleton />
                  }
                  </Grid>
                  <Grid item xs={12}>
                    <CssTextField
                      fullWidth
                      align="center"
                      placeholder={labelReady ? labels("E_FP_NEW_PASSWORD_PLACEHOLDER") : ''}
                      variant="standard"
                      className={classes.inpField}
                      name="password"
                      value={password}
                      type="password"
                      onChange={handleChange}
                      onBlur={passwordBlur}
                      autoComplete="off"
                      error={
                        passwordRequire || passwordError || confirmPasswordError
                      }
                    />
                  </Grid>
                  {
                    labelReady ?
                  <Typography className={classes.mobileNumberError}>
                    {passwordRequire
                      ? labels("E_FP_NEW_PASSWORD_ERROR")
                      : passwordError
                      ? labels("E_FP_NEW_PASSWORD_VALIDATION_ERROR")
                      : null}
                  </Typography>
                  : <Skeleton />
                  }
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                  {
                    labelReady ?
                    <Typography
                      variant="subtitle2"
                      align="left"
                      className={classes.blackColor}
                    >
                      {labels("E_FP_CONFIRM_PASSWORD") + "*"}
                    </Typography>
                    : <Skeleton />
                  }
                  </Grid>
                  <Grid item xs={12}>
                    <CssTextField
                      align="center"
                      placeholder={labelReady ? labels("E_FP_CONFIRM_PASSWORD_PLACEHOLDER") : ''}
                      variant="standard"
                      type="password"
                      fullWidth
                      autoComplete="off"
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={handleChange}
                      onKeyPress={keypress}
                      onBlur={confirmPasswordBlur}
                      error={confirmPasswordRequire || confirmPasswordError}
                    />
                  </Grid>
                  {
                    labelReady ?
                  <Typography className={classes.mobileNumberError}>
                    {confirmPasswordRequire
                      ? labels("E_FP_CONFIRM_PASSWORD_ERROR")
                      : confirmPasswordError
                      ? labels("E_FP_CONFIRM_PASSWORD_VALIDATION_ERROR")
                      : null}
                  </Typography>
                  : <Skeleton/>
                  }
                </Grid>
              </Grid>
              {confirmPasswordRequire || confirmPasswordError|| passwordRequire || passwordError || password==='' || confirmPassword==='' ? (null) : (<>
              {!confirmPasswordError && errorMessage?.length && labelReady ? (
                <Grid item xs={12} >
                  <Alert severity="error" className={classes.alertStyles}>
                    <Typography
                      className={classes.mt4}
                      align="left"
                      dangerouslySetInnerHTML={{
                        __html: errorMessage,
                      }}
                    />
                  </Alert>
                </Grid>
              ) : null}</>) }
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={updatePassword}
                  data-sitekey={config.recaptcha.SITE_KEY}
                  data-action="register"
                  className={[classes.loginSubmitBtn, classes.cursor]}
                >
                  {labelReady ? labels("E_FP_SUBMIT_BUTTON") : <Skeleton />}
                  {isLoading ? (
                    <CircularProgress
                      size={18}
                      className={classes.circularProgressColor}
                    />
                  ) : (
                    " "
                  )}
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  variant="subtitle2"
                  onClick={() => {
                    history.push(routePaths?.LOGIN);
                  }}
                  className={classes.cancelButton}
                >
                  {labelReady ? labels("E_FP_CANCEL_BUTTON") : <Skeleton />}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.infoListHeader}>
                {
                  labelReady ?
                  <Typography variant="caption">
                    {labels("E_FP_IMPORTANT_INSTRUCTION_HEADING")}
                  </Typography>
                  : <Skeleton />
                }
                </div>
                <div className={classes.infoListItem}>
                {
                  labelReady ?
                  <Typography variant="caption">
                    1.&nbsp;{labels("E_FP_IMPORTANT_INSTRUCTION_1")}
                  </Typography>
                  : <Skeleton />
                }
                </div>
                <div className={classes.infoListItem}>
                {
                  labelReady ?
                  <Typography variant="caption">
                    2.&nbsp;{labels("E_FP_IMPORTANT_INSTRUCTION_2")}
                  </Typography>
                  : <Skeleton />
                }
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
